import React from 'react';

import { REVIEW_TEXTS } from 'constants/ProjectConstants';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import ReviewsCompletedByMeAGGrid from './ReviewsCompletedByMeAGGrid';
import { useReviewFormsList } from './hooks/dataHooks';

const ReviewsCompletedByMe = ({ selectedTableRef, selectedTableId, selectedReviewCycleId }) => {
  const { data: reviewsListData, isLoading } = useReviewFormsList({
    reviewCycleId: selectedReviewCycleId,
    sectionId: selectedTableId,
    reactQueryKey: REACT_QUERY_KEYS.reviewsLanding.completedByMe,
  });

  const tableDataColumns = reviewsListData?.data?.columns ?? [];
  const tableDataValues = reviewsListData?.data?.values ?? [];

  return (
    <ReviewsCompletedByMeAGGrid
      selectedTableRef={selectedTableRef}
      columns={tableDataColumns}
      rows={tableDataValues}
      selectedTableId={selectedTableId}
      loading={isLoading}
      errorMessage={REVIEW_TEXTS.LANDING_PAGE_REVIEWS_TO_COMPLETE.ERROR_MSG}
    />
  );
};

export default ReviewsCompletedByMe;
